module.exports = __webpack_public_path__ + "static/media/hold-phone-up.7f55700a.png";